/* eslint-disable default-case */
/* eslint-disable react-hooks/exhaustive-deps */
import ButtonCustom from "components/Atoms/Button";
import { FormStyles } from "./styles";
import InputBase from "components/Atoms/InputBase";
import { useCallback, useEffect, useMemo, useState } from "react";
import { formatNumber } from "utils/common";
import { toastMessage } from "utils/toastMessage";
import { MESSAGE } from "constants/message";
import { useDispatch, useSelector } from "react-redux";
import { ModalChooseCoin } from "../ModalChooseCoin";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CircularProgress } from "@mui/material";
import {
  allowanceToken,
  approveToken,
  depositCoin,
  depositToken,
  switchNetwork,
} from "utils/web3";
import {
  useWeb3ModalAccount,
  useWeb3ModalProvider,
} from "@web3modal/ethers/react";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import HistoryIcon from "@mui/icons-material/History";
import Lottie from "react-lottie";
import loadingLottie from "assets/lottie/arrow-down.json";
import loadingBoxLottie from "assets/lottie/loading-chart.json";
import { swapSelector } from "redux/slice/swapSlice";
import { ethers, formatUnits, JsonRpcProvider } from "ethers";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { createSwap, rqPairSwap } from "services/swap";
import HistorySwap from "../History";
import AlertDialogSlide from "../Dialog";

const defaultOption = (data) => {
  return {
    loop: true,
    autoplay: true,
    animationData: data,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
};

export default function FromSwap() {
  const dispatch = useDispatch();
  const { coinSwap, pairSwap } = useSelector(swapSelector);
  const { walletProvider } = useWeb3ModalProvider();
  const { isConnected, address } = useWeb3ModalAccount();

  const [coinFrom, setCoinFrom] = useState(null);
  const [coinTo, setCoinTo] = useState(null);
  const [openModalFrom, setOpenModalFrom] = useState(false);
  const [openModalTo, setOpenModalTo] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [balanceFrom, setBalanceFrom] = useState(0);
  const [balanceTo, setBalanceTo] = useState(0);
  const [pair, setPair] = useState(null);
  // HANDLE CHANGE AMOUNT
  const handleChangeAmount = (value) => {
    setCoinFrom({ ...coinFrom, amount: value });
    setCoinTo({
      ...coinTo,
      amount:
        ((value - (value * pair?.fee) / 100) / coinTo?.price) * coinFrom?.price,
    });
  };

  // HANDLE SEND
  const handleSend = async () => {
    try {
      let hash = "";
      switch (coinFrom?.type) {
        case "COIN":
          hash = await depositCoin(
            walletProvider,
            pair.receive_contract,
            ethers.parseUnits(coinFrom?.amount.toString(), 18)
          );
          break;

        case "TOKEN":
          const allowance = await allowanceToken(
            walletProvider,
            coinFrom.contract_address,
            coinFrom.abi,
            address,
            pair.receive_contract,
            coinFrom?.decimals
          );
          if (
            coinFrom?.network?.symbol === "ETH" &&
            allowance > 0 &&
            allowance < Number(coinFrom.amount)
          ) {
            await approveToken(
              walletProvider,
              coinFrom.contract_address,
              coinFrom.abi,
              pair.receive_contract,
              0,
              coinFrom?.decimals
            );
          }
          if (allowance < Number(coinFrom.amount)) {
            await approveToken(
              walletProvider,
              coinFrom.contract_address,
              coinFrom.abi,
              pair.receive_contract,
              coinFrom?.amount,
              coinFrom?.decimals
            );
          }
          hash = await depositToken(
            walletProvider,
            pair.receive_contract,
            ethers.parseUnits(coinFrom?.amount.toString(), coinFrom.decimals)
          );
          break;
      }

      createSwap(dispatch, {
        pair_id: pair.id,
        amount: coinFrom?.amount,
        hash,
      });
      setTimeout(() => {
        getBalanceForCoin(coinFrom).then(setBalanceFrom);
        getBalanceForCoin(coinTo).then(setBalanceTo);
      }, 3000);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // HADNLE SWAP
  const handleSwap = async () => {
    setLoading(true);
    if (coinFrom && coinFrom.amount > 0) {
      if (coinFrom.amount < pair.min) {
        setLoading(false);
        toastMessage(
          `Minimum ${formatNumber(pair.min)} ${coinFrom.symbol}`,
          MESSAGE.WARNING
        );
      } else if (coinFrom.amount > pair.max) {
        setLoading(false);
        toastMessage(
          `Maximum ${formatNumber(pair.max)} ${coinFrom.symbol}`,
          MESSAGE.WARNING
        );
      } else {
        handleSend();
      }
    } else {
      setLoading(false);
      toastMessage("Please enter quantity!", MESSAGE.ERROR);
    }
  };

  const coinFromId = useMemo(() => coinFrom?.id, [coinFrom?.id]);
  const coinToId = useMemo(() => coinTo?.id, [coinTo?.id]);

  useEffect(() => {
    const fetchData = async () => {
      if (coinFromId) {
        setLoading(true);
        await rqPairSwap(dispatch, { from_id: coinFromId });
        await switchNetwork({
          walletProvider,
          chainID: coinFrom?.network?.chain_id,
          chainName: coinFrom?.network?.name,
          rpcUrl: coinFrom?.network?.rpc_url,
          symbol: coinFrom?.network?.symbol,
          decimals: coinFrom?.network?.decimals,
          explorerUrl: coinFrom?.network?.explorer_url,
        });
        setLoading(false);
      }
    };
    fetchData().catch(console.error);
  }, [coinFromId, isConnected]);

  useEffect(() => {
    if (pairSwap?.length > 0) {
      setCoinTo(pairSwap?.map((item) => item.to)[0]);
    }
  }, [pairSwap]);

  useEffect(() => {
    if (coinSwap?.length > 0) {
      const coinDefault = coinSwap?.find((item) => item.symbol === "USDT");
      setCoinFrom({ ...coinDefault, amount: "" });
      rqPairSwap(dispatch, { from_id: coinDefault.id });
    }
  }, [coinSwap]);

  const getBalanceForCoin = useCallback(
    async (coin) => {
      if (!coin || !address) return 0;
      try {
        const provider = new JsonRpcProvider(coin.network?.rpc_url);
        let balance = 0;

        if (coin.type === "TOKEN") {
          if (!coin.contract_address || !coin.abi) return 0;
          const contract = new ethers.Contract(
            coin.contract_address,
            coin.abi,
            provider
          );
          balance = await contract.balanceOf(address);
        } else if (coin.type === "COIN") {
          balance = await provider.getBalance(address);
        }
        return parseFloat(formatUnits(balance, coin.decimals));
      } catch (error) {
        return 0;
      }
    },
    [address]
  );

  useEffect(() => {
    getBalanceForCoin(coinFrom).then(setBalanceFrom);
    if (coinFromId === 3) {
      setOpen(true)
    }
  }, [coinFromId, getBalanceForCoin]);

  useEffect(() => {
    getBalanceForCoin(coinTo).then(setBalanceTo);
  }, [coinToId, getBalanceForCoin]);

  useEffect(() => {
    if (coinFrom && coinTo) {
      const selectPair = pairSwap.find(
        (item) => item?.from?.id === coinFrom?.id && item?.to?.id === coinTo?.id
      );
      setPair(selectPair);
    }
  }, [coinFrom, coinTo]);

  return (
    <FormStyles.Main>
      <AlertDialogSlide open={open} setOpen={setOpen} />
      {openHistory && (
        <HistorySwap
          open={openHistory}
          handleClose={() => setOpenHistory(false)}
        />
      )}

      <ModalChooseCoin
        open={openModalFrom}
        handleClose={() => setOpenModalFrom(false)}
        onChange={(value) => {
          setCoinFrom({ ...value, amount: "" });
          setCoinTo({ ...coinTo, amount: "" });
        }}
        defaultValue={coinFrom}
        options={coinSwap}
      />
      <ModalChooseCoin
        open={openModalTo}
        handleClose={() => setOpenModalTo(false)}
        onChange={(value) => {
          setCoinFrom({ ...coinFrom, amount: "" });
          setCoinTo({ ...value, amount: "" });
        }}
        defaultValue={coinTo}
        options={pairSwap?.map((item) => item.to)}
      />
      <FormStyles.Head>
        <div>
          <FormStyles.Title>Swap</FormStyles.Title>
          <FormStyles.SubTitle>Trade tokens in an instant</FormStyles.SubTitle>
        </div>
        {isConnected && (
          <HistoryIcon
            sx={{ cursor: "pointer" }}
            onClick={() => setOpenHistory(true)}
          />
        )}
        {/* <Image3DSplit imageUrl={imgFromSwap} /> */}
      </FormStyles.Head>
      {coinFrom ? (
        <FormStyles.CoinInfo onClick={() => setOpenModalFrom(true)}>
          <div>
            <div style={{ position: "relative" }}>
              <img
                height="30"
                width="30"
                style={{ borderRadius: "50%" }}
                alt={coinFrom?.name}
                src={coinFrom?.image}
              />
              <img
                height="15"
                width="15"
                alt={coinFrom?.name}
                src={coinFrom?.network?.image}
                style={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  borderRadius: "50%",
                }}
              />
            </div>
            <p>
              {coinFrom?.symbol}{" "}
              <span style={{ fontWeight: "normal", fontSize: "12px" }}>
                ({coinFrom?.network?.key})
              </span>{" "}
            </p>
            <ExpandMoreIcon sx={{ marginLeft: "-7px" }} />
          </div>
          <span>
            <AccountBalanceWalletIcon fontSize="15px" />{" "}
            {formatNumber(balanceFrom)}
          </span>
        </FormStyles.CoinInfo>
      ) : (
        <CircularProgress color="primary" size="1.5rem" />
      )}
      <FormStyles.InputFrom>
        <InputBase
          placeholder="0"
          name="from"
          type="number"
          onWheel={(e) => e.preventDefault()}
          onChange={(e) => handleChangeAmount(e.target.value)}
          value={coinFrom?.amount ?? ""}
        />
        <FormStyles.ButtonMax
          className="btn-max"
          onClick={() => handleChangeAmount(balanceFrom)}
        >
          MAX
        </FormStyles.ButtonMax>
      </FormStyles.InputFrom>
      <FormStyles.IconSwap>
        <Lottie options={defaultOption(loadingLottie)} />
      </FormStyles.IconSwap>
      {coinTo ? (
        <FormStyles.CoinInfo onClick={() => setOpenModalTo(true)}>
          <div>
            <div style={{ position: "relative" }}>
              <img
                height="30"
                width="30"
                alt={coinTo?.name}
                src={coinTo?.image}
              />
              <img
                height="15"
                width="15"
                alt={coinTo?.name}
                src={coinTo?.network?.image}
                style={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  borderRadius: "50%",
                }}
              />
            </div>
            <p>
              {coinTo?.symbol}{" "}
              <span style={{ fontWeight: "normal", fontSize: "12px" }}>
                ({coinTo?.network?.key})
              </span>{" "}
            </p>
            <ExpandMoreIcon sx={{ marginLeft: "-7px" }} />
          </div>

          <span>
            <AccountBalanceWalletIcon fontSize="15px" />{" "}
            {formatNumber(balanceTo)}
          </span>
        </FormStyles.CoinInfo>
      ) : (
        <CircularProgress color="primary" size="1.5rem" />
      )}

      <InputBase
        onChange={() => { }}
        value={formatNumber(coinTo?.amount || 0)}
        placeholder="0"
        name="to"
        disabled
      />
      <FormStyles.End>
        <span>
          1 {coinFrom?.symbol}{" "}
          <SwapHorizIcon fontSize="small" sx={{ color: "#2acbfe" }} />{" "}
          {formatNumber((1 / coinTo?.price) * coinFrom?.price)} {coinTo?.symbol}
        </span>
        <span>
          Fee: {formatNumber((coinFrom?.amount * pair?.fee) / 100)}{" "}
          {coinFrom?.symbol}
        </span>
      </FormStyles.End>
      <FormStyles.End>
        <span
          style={
            coinFrom?.amount && coinFrom?.amount < pair?.min
              ? { color: "red" }
              : {}
          }
        >
          Min: {pair?.min ? formatNumber(pair?.min) : 0} {coinFrom?.symbol}
        </span>
        <span
          style={
            coinFrom?.amount && coinFrom?.amount > pair?.max
              ? { color: "red" }
              : {}
          }
        >
          Max: {pair?.min ? formatNumber(pair?.max) : 0} {coinFrom?.symbol}
        </span>
      </FormStyles.End>
      {isConnected ? (
        <ButtonCustom onClick={handleSwap} disabled={loading}>
          {loading ? (
            <Lottie
              options={defaultOption(loadingBoxLottie)}
              style={{
                width: "35px",
                height: "35px",
                marginTop: "-5px",
                marginBottom: "-5px",
                padding: 0,
              }}
            />
          ) : (
            "SWAP"
          )}
        </ButtonCustom>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "15px",
          }}
        >
          <w3m-button />
        </div>
      )}
    </FormStyles.Main>
  );
}
